<template>
  <div id="root">
    <div class="fixed-background">
      <main>
        <div class="container">
          <b-row class="h-100">
            <b-colxx xxs="12" md="10" class="mx-auto my-auto">
              <b-card class="auth-card" no-body>
                <div class="position-relative image-side">
                  <p class="text-white h2">سامانه شهید باقری</p>
                  <p class="white mb-0">
                    پایگاه جامع اطلاعات نیرویی اتحادیه انجمن‌های اسلامی
                    دانش‌آموزان
                  </p>
                </div>
                <div class="form-side">
                  <router-link tag="a" to="/">
                    <img
                      src="../../assets/img/logo.png"
                      style="height: 100px"
                      class="mb-5"
                    />
                  </router-link>
                  <h6 class="mb-4">گفتند یافت می‌نشود، جُسته‌ایم ما!</h6>
                  <p class="mb-0 text-muted text-small mb-0">
                    متأسفیم، صفحه موردنظر شما پیدا نشد
                  </p>
                  <p class="display-1 font-weight-bold mb-5">404</p>
                  <b-button
                    type="submit"
                    variant="primary"
                    size="lg"
                    class="btn-shadow"
                    @click="goBack"
                    >بازگشت به صفحه قبل</b-button
                  >
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goBack() {
      this.$router.push("/");
    },
  },
  mounted: function () {
    document.body.classList.add("background");
  },
  beforeDestroy() {
    document.body.classList.remove("background");
  },
};
</script>
